import { Box, Stack } from '@mui/material'
import { useState } from 'react'
import { AccordionTransition } from '../../common/AccordionTransition'
import { FilesFieldCard } from '../../feat/editItinerary/components/filesFieldCard'
import { TextFieldCard } from '../../feat/editItinerary/components/textFieldCard'
import { Expand } from '../../home/components/expand'
import i18n from '../../i18n/i18next'
import { useFormatValue } from '../hooks/useFormatValue'
import { EditButton } from './editButton'
import { UsersList } from './usersList'
interface IRoomBodyProps {
    id?: string
    data: any
    renderOptions: IRoomBodyOptions
}

interface IRoomBodyOptions {
    listFieldId: number
    icon?: string
    fallbackText?: string
    editPageId?: number
    userListKey: string
}
export const RoomBody = ({ id, data, renderOptions }: IRoomBodyProps) => {
    const [chevroClickOpen, setChevroClickOpen] = useState<boolean>(false)
    const { formatValue } = useFormatValue()

    const userList = () => {
        const hideUserList = data?.guests?.length === 0

        return (
            <>
                <Stack justifyContent={'space-between'} direction={'row'}>
                    {hideUserList ? (
                        <div />
                    ) : (
                        <Box
                            height={'24px'}
                            onClick={() => {
                                setChevroClickOpen(!chevroClickOpen)
                            }}
                        >
                            <Expand expanded={chevroClickOpen} />
                        </Box>
                    )}

                    <EditButton
                        id={id}
                        data={data}
                        renderOptions={{ pageId: renderOptions.editPageId }}
                    />
                </Stack>
                {!hideUserList && (
                    <AccordionTransition open={chevroClickOpen}>
                        <UsersList
                            id={id}
                            data={data}
                            renderOptions={{
                                hideChat: true,
                                users: renderOptions.userListKey,
                            }}
                        />
                    </AccordionTransition>
                )}
            </>
        )
    }

    return (
        <Stack spacing={'16px'}>
            <TextFieldCard
                id={id}
                description={i18n.t('edit-itinerary.fields.314')}
                text={
                    data.checkIn ? formatValue(data.checkIn, 'datetime') : null
                }
            />
            <TextFieldCard
                description={i18n.t('edit-itinerary.fields.315')}
                text={
                    data.checkOut
                        ? formatValue(data.checkOut, 'datetime')
                        : null
                }
            />
            <TextFieldCard
                description={i18n.t('edit-itinerary.fields.313')}
                text={data.roomType}
            />
            <TextFieldCard
                id={id}
                description={i18n.t('edit-itinerary.fields.316')}
                text={data.comments}
            />
            <FilesFieldCard
                id={id}
                description={i18n.t('edit-itinerary.fields.documents')}
                files={data.documents}
            />
            {userList()}
        </Stack>
    )
}
